import React from "react";
import "./Terminal.css";

/**
 * Componente Terminal - Simula una terminal estilo macOS
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenido a renderizar dentro de la terminal
 * @param {string} props.className - Clases CSS adicionales
 * @param {boolean} props.showControls - Mostrar controles de ventana (default: true)
 */
export const Terminal = ({
  children,
  className = "",
  showControls = true,
}) => {
  return (
    <div className={`terminal-container ${className}`}>
      {showControls && (
        <div className="terminal-header">
          <div className="terminal-controls">
            <div className="terminal-control-dot terminal-control-close"></div>
            <div className="terminal-control-dot terminal-control-minimize"></div>
            <div className="terminal-control-dot terminal-control-maximize"></div>
          </div>
        </div>
      )}
      <div className="terminal-content">
        <pre className="terminal-pre">
          <code className="terminal-code">{children}</code>
        </pre>
      </div>
    </div>
  );
};

export default Terminal;








